import React, {FC, useState} from 'react';
import ArrowLeft from 'assets/icons/arrow-left.svg';
import ArrowRight from 'assets/icons/arrow-right.svg';

import {usePhotos} from './usePhotos';

import * as styles from './styles.module.scss';

interface PhotosSlider {
	urls: string[];
}

const PhotosSlider: FC<PhotosSlider> = ({urls}) => {
	const images = usePhotos(urls);
	const [index, setIndex] = useState<number>(0);

	const selected = (): string[] => {
		const clamp = (v: number) => {
			if (v < 0) {
				return images.length - (-(v + 1) % images.length) - 1;
			}
			return v % images.length;
		};

		return [
			images[clamp(index + 0)],
			images[clamp(index + 1)],
			images[clamp(index + 2)],
		];
	};

	const prev = () => setIndex(index - 1);
	const next = () => setIndex(index + 1);

	return images.length === 0 ? null : (
		<div className={styles.wrapper}>
			<div className={styles.title}>Photos</div>
			<div className={styles.slider}>
				{selected().map((src, i) => (
					<div className={styles.image} key={i}>
						<img src={src} alt='' key={i} />
					</div>
				))}
			</div>
			<div className={styles.controls}>
				<div onClick={prev}>
					<ArrowLeft />
				</div>
				<div onClick={next}>
					<ArrowRight />
				</div>
			</div>
		</div>
	);
};

export default PhotosSlider;
